import { FaFacebook, FaApple, FaGoogle } from "react-icons/fa";
import visaCard from "../../assets/images/visa.png";
import masterCard from "../../assets/images/mastercard.png";
import unionpay from "../../assets/images/unionpay.png";
import americanexpress from "../../assets/images/americanexpress.png";
import jcb from "../../assets/images/jcb.png";
import discover from "../../assets/images/discover.png";
import { Link } from "react-router-dom";
import { FaLocationDot } from "react-icons/fa6";
import { IoIosInformationCircle } from "react-icons/io";
import { PiChatTextFill } from "react-icons/pi";
import { FaLocationArrow } from "react-icons/fa6";
import { IoPersonSharp } from "react-icons/io5";
import { RiDeleteBin5Fill } from "react-icons/ri";
import { MdVerified } from "react-icons/md";
import { HiMiniPresentationChartLine } from "react-icons/hi2";
import { GiShakingHands } from "react-icons/gi";
import { FaSearchDollar } from "react-icons/fa";
import { FaHandHoldingDollar } from "react-icons/fa6";
import { FaQuestion } from "react-icons/fa";
import { FaCalendarAlt } from "react-icons/fa";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import { BsFillAwardFill } from "react-icons/bs";
import { FaAd } from "react-icons/fa";
import { ImUserCheck } from "react-icons/im";

const socialLogin = [
  { name: "facebook", icon: <FaFacebook className="facebook-icon" /> },
  { name: "apple", icon: <FaApple className="apple-icon" /> },
  { name: "google", icon: <FaGoogle className="google-icon" /> },
];

const authTypes = [
  "signIn",
  "signUp",
  "forgotPassword",
  "verifyCode",
  "resetPassword",
];

// Default coordinates for London, England
const latitude = 51.5072;
const longitude = 0.1276;

// notificationFlags.js
const notificationFlags = {
  noInternet: false,
  enableLocation: false,
};

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const days = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const bookingStatusTabs = [
  { id: 1, status: -1, label: "All" },
  { id: 2, status: 0, label: "Pending" },
  { id: 3, status: 1, label: "Completed" },
  { id: 4, status: 2, label: "Rejected" },
  { id: 5, status: 4, label: "In-Progress" },
  { id: 6, status: 5, label: "Admin Assigned" },
];

const bookingStatusDetails = [
  { id: 1, status: 0, label: "Pending" },
  { id: 2, status: 1, label: "Completed" },
  { id: 3, status: 2, label: "Rejected" },
  { id: 4, status: 3, label: "Responded" },
  { id: 5, status: 4, label: "In-Progress" },
  { id: 6, status: 5, label: "Admin Assigned" },
  { id: 7, status: 6, label: "Amended" },
];

const bookingDecisions = [
  {
    id: 1,
    label: "Accept",
    color: "#02B563",
  },
  {
    id: 2,
    label: "Reject",
    color: "#FF1D6A",
  },
];

const cardImageSrc = {
  visa: visaCard,
  mastercard: masterCard,
  unionpay: unionpay,
  amex: americanexpress,
  jcb: jcb,
  discover: discover,
};

const transactionType = {
  QUOTE_ACCEPT: "Quote Accept",
  AMEND_ACCEPT: "Amend Accept",
  REFUND: "Refund",
  PAYOUT: "Payout",
};

const colorClasses = {
  "#00B517": "text-green-600",
  "#FF7C17": "text-orange-500",
  "#FAB700": "text-yellow-400",
  "#3879F0": "text-blue-500",
  "#42425B": "text-gray-700",
  "#FF1D6A": "text-pink-600",
  "#02B563": "text-green-700",
  "#FA7B00": "text-orange-600",
  "#6262E1": "text-indigo-600",
};

const FaqsData = [
  {
    icon: <FaLocationDot />,
    title: "How can I enter my location",
    color: "#00B517",
    key: 1,
    content: (
      <>
        By clicking the{" "}
        <b>location icon (represented by infographic see image below)</b>{" "}
        button, the pin will be automatically placed at your exact spot. Move
        the map so the pin is at your precise location. If your precise location
        details aren't shown, allow the pinned location details in the text box.
        Click "Add manually," input your address information, and click "Save."
        Once submitted, the manually entered data will be visible in your
        profile. Remember to grant Mobrage permission to access your location in
        your phone settings while using the app.
      </>
    ),
  },
  {
    icon: <FaHandHoldingDollar />,
    title: "How are you going to make money out of Mobrage?",
    color: "#FF7C17",
    key: 2,
    content:
      "Mobrage earns revenue through a commission-based model on bookings made through the platform. Vehicle experts are charged a small service fee per successful transaction. Additionally, we offer premium promotional features, including homepage and community forum ad placements, for experts who want to boost visibility and attract more bookings.",
  },
  {
    icon: <FaSearchDollar />,
    title: "Is Mobrage free for everyone?",
    color: "#FAB700",
    key: 3,
    content: (
      <>
        <p>Mobrage is free for vehicle owners.</p>
        Vehicle experts can sign up and list their services at no cost. However,
        a small commission fee is applied to each successful booking made
        through the platform. This allows us to maintain the platform and
        continue building features that benefit both users and experts.
      </>
    ),
  },
  {
    icon: <FaHandHoldingDollar />,
    title: "How do you use the data I provide?",
    color: "#3879F0",
    key: 4,
    content: (
      <>
        At Mobrage, we take your data privacy seriously. Your personal data is
        safeguarded from third parties, including marketers and advertisers. We
        only retain the necessary information required for our platform to
        function effectively. To understand in detail how your data is used,
        please visit our{" "}
        <Link
          to={"https://mobrage.com/privacy-policy/"}
          target="_blank"
          className="font-semibold text-[#fab700]"
        >
          Privacy Policy.
        </Link>{" "}
        Rest assured, we are fully compliant with GDPR regulations, prioritizing
        your data security.
      </>
    ),
  },
  {
    icon: <IoIosInformationCircle />,
    title: "How can I report a post or an individual?",
    color: "#42425B",
    key: 5,
    content: (
      <div className="flex flex-col gap-2">
        <p>To report a post or individual, follow these simple steps: </p>
        <ul className="ml-3">
          <li>
            ● Click on the three dots located at the top right-hand corner of
            the post.
          </li>
          <li>● Select "Report" from the options.</li>
          <li>● Follow the provided instructions and submit your report.</li>
        </ul>
        <p>
          Your feedback helps us maintain a safe and respectful community. Thank
          you for your cooperation!
        </p>
      </div>
    ),
  },
  {
    icon: <PiChatTextFill />,
    title: "How do I start a private chat?",
    color: "#FF1D6A",
    key: 6,
    content: (
      <div className="flex flex-col gap-2">
        <p>To initiate a new chat, follow these quick steps: </p>
        <ul className="ml-3">
          <li>
            ● Click on the three dots at the top right-hand corner of the post.
          </li>
          <li>● Select "Message" from the menu.</li>
          <li>● A new chat window will open—start chatting right away!</li>
        </ul>
      </div>
    ),
  },
  {
    icon: <FaLocationArrow />,
    title: "How do I find an expert near me?",
    color: "#02B563",
    key: 7,
    content: (
      <div className="flex flex-col gap-2">
        <p>Finding a trusted vehicle expert is simple:</p>
        <ol type="1" className="ml-3">
          <li>1. On the homepage, select “Service.”</li>
          <li>
            2. Browse or search through the list of available experts near you.
          </li>
          <li>3. View profiles, compare services, and check availability.</li>
          <li>4. Submit a booking request directly through the platform.</li>
        </ol>
        <p>
          Visit our{" "}
          <Link
            to={"https://mobrage.com/how-it-works/"}
            target="_blank"
            className="font-semibold text-[#fab700]"
          >
            "How It Works"
          </Link>{" "}
          page to explore more!
        </p>
      </div>
    ),
  },
  {
    icon: <GiShakingHands />,
    title: "Do you charge a commission fee for bookings requested to experts?",
    color: "#FA7B00",
    key: 8,
    content:
      "Yes. A commission fee is charged to service providers for bookings completed through the Mobrage platform. This fee is automatically deducted from the transaction, allowing experts to focus on delivering great service without worrying about manual invoicing or payments.",
  },
  {
    icon: <IoPersonSharp />,
    title: "How can I update my business profile?",
    color: "#3879F0",
    key: 9,
    content: (
      <div className="flex flex-col gap-2">
        <p>
          To update your business profile as an expert, follow these steps:{" "}
        </p>
        <ul className="ml-3">
          <li>● On the homepage, click on settings</li>
          <li>● Select Business Information</li>
          <li>
            ● Update your business information and click "Save" to confirm the
            changes.
          </li>
        </ul>
      </div>
    ),
  },
  {
    icon: <PiChatTextFill />,
    title: "How do I submit a quote?",
    color: "#42425B",
    key: 10,
    content: (
      <div className="flex flex-col gap-2">
        <p>
          If you're a service provider and would like to submit a quote in
          response to a job or enquiry:
        </p>
        <ol type="1" className="ml-3">
          <li>1. Go to the Bookings or Quotes section in your dashboard.</li>
          <li>2. Select the request you'd like to respond to.</li>
          <li>3. Enter your service details, estimated cost, and date/time.</li>
          <li>4. Tap “Submit Quote”, the user will be notified instantly.</li>
        </ol>
        <p>
          Need help? Our support team is available in-app or via email to guide
          you through the process.
        </p>
      </div>
    ),
  },
  {
    icon: <FaAd />,
    title: "How can I advertise on Mobrage?",
    color: "#FA7B00",
    key: 10,
    content: (
      <>
        Experts can easily promote their business, special offers, sales, and
        more on Mobrage. These ads will be prominently displayed on the app's
        homepage and will run for 24 hours. For further details, visit our
        dedicated{" "}
        <i className="text-[#D0AD43] font-semibold">Advertising page</i> to
        learn more.
      </>
    ),
  },
  {
    icon: <ImUserCheck />,
    title: "Who can advertise on Mobrage?",
    color: "#42425B",
    key: 10,
    content: "Currently, advertising on Mobrage is limited to experts only.",
  },
  {
    icon: <RiDeleteBin5Fill />,
    title: "How can I delete my Mobrage account?",
    color: "#FF1D6A",
    key: 11,
    content: (
      <div className="flex flex-col gap-2">
        <p>To delete your Mobrage account, follow these steps:</p>
        <ul>
          <li>● Go to the "Settings" tab.</li>
          <li>● Select "Delete Account."</li>
          <li>● Enter your password to confirm the deletion.</li>
        </ul>
      </div>
    ),
  },
  {
    icon: <MdVerified />,
    title: "How can I verify my business?",
    color: "#02B563",
    key: 12,
    content: (
      <div className="flex flex-col gap-2">
        <p>To verify your business, follow these steps:</p>
        <ul>
          <li>● Go to the "Settings" tab.</li>
          <li>● Select "Verify Business."</li>
          <li>● Upload a proof of business and click submit.</li>
        </ul>
      </div>
    ),
  },
];

const benefitsData = [
  {
    icon: <HiMiniPresentationChartLine />,
    title: "Enhanced Business Presentation",
    color: "#00B517",
    key: 1,
    content:
      "Elevate your business image by creating a professional profile that showcases your expertise and services.",
  },
  {
    icon: <GiShakingHands />,
    title: "Exclusive Partner Benefits",
    color: "#FF7C17",
    key: 2,
    content:
      "Gain full access to a wide array of partner discounts from our trusted collaborators, providing you with cost-saving opportunities across various services.",
  },
  {
    icon: <FaSearchDollar />,
    title: "Low Commission Fees",
    color: "#FAB700",
    key: 3,
    content: (
      <div className="flex flex-col gap-1">
        <h3 className="font-semibold">Low Commission Fees</h3>A 15% commission
        fee is charged to service providers for bookings completed through the
        Mobrage platform. This fee is automatically deducted from the
        transaction, allowing experts to focus on delivering great service
        without worrying about manual invoicing or payments.
      </div>
    ),
  },
  {
    icon: <FaHandHoldingDollar />,
    title: "Tip Retention",
    color: "#3879F0",
    key: 4,
    content:
      "Keep the entirety of the tips you receive from satisfied customers, further enhancing your income potential and rewarding exceptional service.",
  },
  {
    icon: <FaQuestion />,
    title: "Unlimited Job Requests",
    color: "#42425B",
    key: 5,
    content:
      "Receive an unlimited number of job requests, opening up the doors to more opportunities and increased revenue potential.",
  },
  {
    icon: <FaCalendarAlt />,
    title: "Free Booking Calendar",
    color: "#FF1D6A",
    key: 6,
    content:
      "Utilize our free booking calendar tool to efficiently manage your schedule, ensuring a seamless and organized workflow.",
  },
  {
    icon: <RiVerifiedBadgeFill />,
    title: "Profile Verification Badge",
    color: "#02B563",
    key: 7,
    content:
      "Earn a verification badge for your profile, instilling trust and credibility in potential clients who seek reliable service providers.",
  },
  {
    icon: <BsFillAwardFill />,
    title: "Milestone Achievement Badges",
    color: "#FA7B00",
    key: 8,
    content:
      "Showcase your expertise and dedication by earning milestone badges upon successfully completing jobs, demonstrating your commitment to excellence.",
  },
  {
    icon: <IoPersonSharp />,
    title: "Community Engagement",
    color: "#FAB700",
    key: 9,
    content:
      "Connect with fellow users, freely express your thoughts, and engage in discussions within our post forum.",
  },
  {
    icon: <PiChatTextFill />,
    title: "Real-Time Communication",
    color: "#6262E1",
    key: 10,
    content:
      "Communicate directly with customers, friends, and family using our convenient in-app chat messenger.",
  },
];

export {
  socialLogin,
  authTypes,
  latitude,
  longitude,
  notificationFlags,
  months,
  bookingStatusTabs,
  bookingStatusDetails,
  bookingDecisions,
  cardImageSrc,
  transactionType,
  colorClasses,
  FaqsData,
  benefitsData,
  days,
};
